import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import { production_chart, room_types_chart, adr_chart } from "../widgets/Charts";
import Helpers, { dateFormat, number_format, windowsActive } from "../../../../config/Helpers";
import ReactEcharts from "echarts-for-react";
import axios from "axios";

const postUrlLogin = API_URL + "widgets";

class General extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            array_colors : ["#fec400", "#ff7d4d", "#ff4558", "#15d39a"]
        }
        this.getOptionTypeBar   = this.getOptionTypeBar.bind(this);
    }

    getOptionTypeBar = (chart) => {
        let request_set = Object.keys(this.props.response_request).length;

        let xAxis = [], 
        current_year_values = [], 
        last_year_value = [], 
        budget = [], 
        series = [], 
        hotel_series = [], 
        property_legend = [], 
        max_days = [], 
        max_interval = 0,
        min_interval = 0,
        childs_room     = "",
        rooms,
        max_min_reserve = [],
        request_get;

        let $self = this;
        let result
        if (request_set > 0){
            request_get = this.props.response_request;
            if(chart === "data_reserves_production"){
                result    = request_get["data_production_widget"];
                xAxis     = Object.keys(result) 
                Object.keys(result).map(function(key, index){
                    budget[index]                 = result[key]["budget"];
                    current_year_values[index]    = result[key]["current_year_value"];
                    last_year_value[index]        = result[key]["last_year_value"];
                })
            }else if(chart === "data_adr"){
                result    = request_get["data_adr_widget"];
                max_days  = request_get["data_max_day_month"];
                max_interval = request_get["data_max_interval"];
                min_interval = request_get["data_min_interval"];
                max_min_reserve = request_get["data_max_min_reserve"];

                Object.keys(result).map(function(key, index){
                    series        = series.concat(result[key]["value"]);
                })
            }else{
                result = request_get["data_room_types"];
                property_legend = result["property_legend"]
                rooms = result["room_type"];
                Object.keys(rooms).map(function (key, index) {
                    if (key !== "children") {
                        hotel_series = hotel_series.concat(rooms[key]);
                    }
                })
                this.state.list_rooms = Object.keys(rooms).map(function (key, index) {
                    const list_childs = rooms[key]["children"];

                    let style_legend = {
                        backgroundColor: rooms[key]["color"],
                    };

                    childs_room = Object.keys(list_childs).map((key_aux, index_aux) => {
                        let style_legend_room = {
                            backgroundColor: list_childs[key_aux].color,
                        };
                        
                        let value_room;
                        if ($self.props.view_results === "room_night"){
                            value_room = list_childs[key_aux].value;
                        }else{
                            value_room = "$" + number_format(list_childs[key_aux].value, 2);
                        }

                        return (
                            <li key={"list-room-reservation-"+index_aux}>
                                <span style={style_legend_room} className="color-type"></span>
                                {list_childs[key_aux].name}:
                                <div className="legend-room">
                                    <span className="value">{value_room}</span>
                                    <span className="percent">{list_childs[key_aux].value_percent}%</span>
                                </div>
                            </li>
                        );
                    })

                    let value_hotel;
                    if ($self.props.view_results === "room_night") {
                        value_hotel = rooms[key].value_hotel;
                    } else {
                        value_hotel = "$" + number_format(rooms[key].value_hotel, 2);
                    }

                    return (<li>
                                <span style={style_legend} className="color-type"></span>
                                    <span className="title">{key}</span>
                                    <div className="legend-hotel">
                                        <span className="value">{value_hotel}</span>
                                        <span className="percent">{rooms[key].value_percent}%</span>
                                    </div>
                                <ul>{childs_room}</ul>
                            </li>)
                })
            }
        }
        if(chart === "data_reserves_production"){
            return production_chart(xAxis, budget, current_year_values, last_year_value, [$self.props.current_year, $self.props.past_year], $self.props.view_results);
        }else if(chart === "data_room_types"){
            return room_types_chart(hotel_series,property_legend);
        }else if(chart === "data_adr"){
            return adr_chart(series, $self.props.view_results, max_days, min_interval, max_interval, max_min_reserve);
        }
    }
    render() {
        return (
            <section>
                <div className={"datagrid-widget production-year"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PRODUCCIÓN</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                <ReactEcharts
                                    option={ windowsActive(this.props, "reservation", "general") === true ? this.getOptionTypeBar("data_reserves_production") : {}}
                                    notMerge={true}
                                    lazyUpdate={true}
                                    onChartReady={this.onChartReadyCallback}
                                    
                                    ref={(e) => { this._echarProduction = e; }}
                                />
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className={"datagrid-widget adr"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PRODUCCIÓN ANUAL</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list chart">
                                    <ReactEcharts
                                        option={windowsActive(this.props, "reservation", "general") === true ? this.getOptionTypeBar("data_adr") : {} }
                                        notMerge={true}
                                        lazyUpdate={true}
                                        theme={"theme_name"}
                                        onChartReady={this.onChartReadyCallback}
                                        
                                        ref={(e) => { this._echarProductionYear = e; }}
                                    />
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className={"datagrid-widget room_type"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PRODUCCIÓN POR HABITACIÓN</span>

                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">

                            </div>
                            <div className="row">
                                <div className="col-md-6 datagrid-list chart">
                                    <ReactEcharts
                                        option={windowsActive(this.props, "reservation", "general") === true ? this.getOptionTypeBar("data_room_types") : {} }
                                        notMerge={true}
                                        lazyUpdate={true}
                                        theme={"theme_name"}
                                        
                                        onChartReady={this.onChartReadyCallback}
                                        ref={(e) => { this._echarRoomType = e; }}
                                    />
                                </div>
                                <div className="col-md-6 datagrid-list list-rooms">
                                    <ul className="list-room-type">
                                        {this.state.list_rooms}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>   
            </section>
        )
    }
}

export default General



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/General.js